/**
 * @module:  原生ui组件模块(延后开发)
 * @author: Liang Huang
 * @date: 2019-09-23 15:12:54
 */
export default function uiMixin(hybrid) {
  var hybridJs = hybrid;
  var innerUtil = hybridJs.innerUtil;
  hybridJs.extendModule('ui', [{
    namespace: 'toast',
    os: ['ywk'],
    params: {
      message: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'message');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    namespace: 'showDebugDialog',
    os: ['ywk'],
    params: {
      debugInfo: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject(rest, 'debugInfo');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    namespace: 'alert',
    os: ['ywk'],
    params: {
      title: '',
      message: '',
      buttonName: '确定',
      // 默认可取消
      cancelable: 1
    },
    // 用confirm来模拟alert
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'message', 'title', 'buttonName');
      args[0].buttonLabels = [args[0].buttonName];
      hybridJs.ui.confirm.apply(this, args);
    }
  }, {
    namespace: 'confirm',
    os: ['ywk'],
    params: {
      title: '',
      message: '',
      buttonLabels: ['取消', '确定'],
      // 默认可取消
      cancelable: 1
    }
  }, {
    namespace: 'prompt',
    os: ['ywk'],
    params: {
      title: '',
      hint: '',
      text: '',
      lines: 1,
      maxLength: 10000,
      buttonLabels: ['取消', '确定'],
      // 默认可取消
      cancelable: 1
    }
  }, {
    namespace: 'actionSheet',
    os: ['ywk'],
    params: {
      items: [],
      // 默认可取消
      cancelable: 1
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      }

      var args = rest;
      var options = args[0];
      var originalItems = options.items;

      options.dataFilter = function (res) {
        var newRes = res;
        var index = -1;
        var content = '';

        if (newRes.result) {
          index = newRes.result.which || 0;
          content = originalItems[index]; // 需要将中文解码

          newRes.result.content = decodeURIComponent(content);
        }

        return newRes;
      };

      args[0] = options;
      hybridJs.callInner.apply(this, args);
    }
  }, {
    namespace: 'popWindow',
    os: ['ywk'],
    params: {
      titleItems: [],
      iconItems: [],
      iconFilterColor: ''
    },

    /**
     * 有横向菜单和垂直菜单2种
     * 可配合setNBRightImage、setNBRightText使用(iOS 不可配合使用)
     */
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      }

      var args = rest;
      var options = args[0];
      var originalItems = options.iconItems; // 处理相对路径问题

      for (var i = 0, len = options.iconItems.length; i < len; i += 1) {
        options.iconItems[i] = innerUtil.getFullPath(options.iconItems[i]);
      }

      options.dataFilter = function (res) {
        var newRes = res;
        var index = -1;
        var content = '';

        if (newRes.result) {
          index = newRes.result.which || 0;
          content = originalItems[index]; // 需要将中文解码

          newRes.result.content = decodeURIComponent(content);
        }

        return newRes;
      };

      args[0] = options;
      hybridJs.callInner.apply(this, args);
    }
  }, {
    namespace: 'pickDate',
    os: ['ywk'],
    params: {
      // 部分设备上设置标题后遮挡控件可不设置标题
      title: '',
      // 默认为空为使用当前时间
      // 格式为 yyyy-MM-dd。
      datetime: ''
    }
  }, {
    namespace: 'pickTime',
    os: ['ywk'],
    params: {
      // 部分设备上设置标题后遮挡控件可不设置标题
      title: '',
      // 默认为空为使用当前时间
      // 格式为 HH:mm
      datetime: ''
    }
  }, {
    namespace: 'pickDateTime',
    os: ['ywk'],
    params: {
      title1: '',
      title2: '',
      // 默认为空为使用当前时间
      // 格式为 yyyy-MM-dd HH:mm
      datetime: ''
    }
  }, {
    namespace: 'showWaiting',
    os: ['ywk'],
    params: {
      message: '加载中...'
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'message');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    namespace: 'closeWaiting',
    os: ['ywk']
  }]);
}